import { render, staticRenderFns } from "./LocalizationSettings.vue?vue&type=template&id=f83881e0&scoped=true&lang=pug&"
import script from "./LocalizationSettings.vue?vue&type=script&lang=js&"
export * from "./LocalizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationSettings.vue?vue&type=style&index=0&id=f83881e0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83881e0",
  null
  
)

/* custom blocks */
import block0 from "./LocalizationSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports